<template>
  <v-dialog :value="isActive" persistent max-width="600" scrollable>
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ isEditMode ? "Actualizar" : "Crear" }} configuración
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 450px">
            <!-- {{ dataToEdit }} -->
            <v-row>
              <!-- Public Identity -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider
                  name="public identity"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.public_identity"
                    :error-messages="errors"
                    label="Public Identity"
                    rounded
                    filled
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Contraseña -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider
                  name="contraseña"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    required
                    filled
                    rounded
                    class="rounded-small"
                    dense
                    label="Contraseña"
                    name="password"
                    prepend-inner-icon="mdi-lock"
                    :append-icon="
                      showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
                    "
                    :type="showPassword ? 'text' : 'password'"
                    color="info"
                    v-model="payload.Password"
                    :error-messages="errors"
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Usuarios -->
              <v-col cols="12" class="py-0">
                <ValidationProvider name="usuarios" rules="" v-slot="{ errors }">
                  <v-select
                    :disabled="isLoading"
                    v-model="payload.user_id"
                    :items="clientList"
                    :error-messages="errors"
                    item-text="name"
                    item-value="id"
                    prepend-inner-icon="mdi-account"
                    label="Usuarios"
                    filled
                    rounded
                  >
                  </v-select>
                </ValidationProvider>
              </v-col>

              <v-col cols="12" class="py-0">
                <v-switch
                  color="success"
                  class="ml-2"
                  v-model="payload.auto_answer"
                  inset
                  label="Contestar llamadas automaticamente"
                  :false-value="0"
                  :true-value="1"
                ></v-switch>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn @click="closeDialog()" class="px-8" color="error" rounded large text>
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            @click="handleSubmit(submitForm)"
            :disabled="isLoading"
            class="px-8"
            color="success"
            rounded
            large
          >
            {{ isEditMode ? "Actualizar" : "Crear" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
import axios from "axios";

export default {
  components: {
    vuescroll,
  },

  props: {
    isActive: {
      type: Boolean,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    dataToEdit: {
      type: Object,
      default: {},
    },
  },

  data() {
    return {
      isLoading: false,
      showPassword: false,
      clientList: [],
      payload: {
        public_identity: "",
        Password: "",
        user_id: "",
        auto_answer: 0,
      },
    };
  },

  created() {
    this.getSelectsInfo();
    this.payload.public_identity = this.dataToEdit.public_identity;
    this.payload.Password = this.dataToEdit.Password;
    this.payload.user_id = this.dataToEdit.user_id;
    this.payload.id = this.dataToEdit.id;
    this.payload.auto_answer = this.dataToEdit.auto_answer;
  },

  methods: {
    resetform() {
      this.payload.public_identity = "";
      this.payload.Password = "";
      this.payload.user_id = "";
      this.payload.user_id = "";
    },

    closeDialog(data = false) {
      this.$emit("close:dialog", data);
    },

    async getSelectsInfo() {
      // this.isLoading = true;

      let endpoints = [`/admin/index_users_select/webrtc`];

      await axios
        .all(endpoints.map((endpoint) => PbxHttpClient.get(endpoint)))
        .then((res) => {
          this.clientList = res[0].data;
        })
        .catch((error) => {
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        });
      // .finally(() => {
      //   this.isLoading = false;
      // });
    },

    async submitForm() {
      this.isLoading = true;

      // const { id, ...payload } = this.payload;

      try {
        const { id, ...payload } = this.payload;
        const { data } = this.isEditMode
          ? await PbxHttpClient.put(`/admin/webrtc/${id}`, payload)
          : await PbxHttpClient.post("/admin/webrtc", payload);
        this.closeDialog(data);

        this.$snotify.success(
          `Configuración ${this.isEditMode ? "actualizada" : "creada"} con éxito.`,
          "¡Hecho!"
        );
      } catch (err) {
        this.$snotify.error("No se pudo realizar la acción.", "¡Error!");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
